import category from "../assets/categories.jpg";
import activity from "../assets/dashboard.jpg";
import favicon from "../assets/favicon.svg";
import home from "../assets/home.jpg";
import logo from "../assets/logo.svg";
import logoBlack from "../assets/logoBlack.svg";
import logoSmall from "../assets/logoSmall.svg";
import users from "../assets/users.jpg";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    logo,
    favicon,
    logoBlack,
    logoSmall,
    category,
    users,
    activity,
    home,
};
